import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { animated, useSpring } from 'react-spring'
import { useDrag } from 'react-use-gesture'

interface ContextualPageProps {
    height?: string
    children?: React.ReactNode
    className?: string
    show: boolean
    onClose?: () => void
    onOpen?: () => void
    open: boolean
}
export function ContextualPage({
    height = '1/2',
    children,
    className,
    show = true,
    onClose = () => {},
    onOpen = () => {},
    open = false,
}: ContextualPageProps) {
    const contextualContainerStyles = classNames(
        'h-screen flex flex-col justify-end fixed top-0 left-0 w-screen pointer-events-none z-50',
    )

    const containerStyles = classNames(
        'shadow-2xl rounded-4xl w-full bg-white p-4 transition-all pointer-events-auto z-50',
        `h-${height}`,
        className,
    )

    const [{ x, y }, set] = useSpring(() => ({ x: 0, y: 0 }))

    const bind = useDrag(({ down, movement: [mx, my] }) => {
        if (my > 30) {
            onClose()
        }
        if (my < -30) {
            onOpen()
        }

        set({ y: down ? (my > 30 ? 30 : my < -30 ? -30 : my) : 0 })
    })

    return (
        <Transition
            appear={true}
            show={show}
            className={contextualContainerStyles}
            enter='transition ease-in-out duration-300 transform'
            enterFrom='translate-y-full'
            enterTo='translate-y-0'
            leave='transition ease-in-out duration-300 transform'
            leaveFrom='translate-y-0'
            leaveTo='translate-y-full'>
            <animated.div
                {...bind()}
                className={containerStyles}
                style={{ x, y, touchAction: 'none' }}>
                <div className='flex flex-row justify-center mb-4 cursor-pointer'>
                    <div className='w-16 h-2 bg-skeleton rounded-xl'></div>
                </div>
                {children}
            </animated.div>
        </Transition>
    )
}
